import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <motion.div
        className="text-center max-w-lg"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="text-8xl font-bold text-[#D4AF37]/30 mb-4">404</div>
        <h1 className="text-3xl md:text-4xl font-bold text-[#1A3625] mb-4">
          Sayfa Bulunamadı
        </h1>
        <p className="text-lg text-[#5C5C5C] mb-8">
          Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#1A3625] text-white px-6 py-3 rounded-full text-base font-medium hover:bg-[#1A3625]/90 transition-colors"
            data-testid="go-home-btn"
          >
            <Home className="w-5 h-5" />
            Ana Sayfaya Dön
          </Link>
          <Link
            to="/market"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#1A3625] text-[#1A3625] px-6 py-3 rounded-full text-base font-medium hover:bg-[#1A3625]/5 transition-colors"
            data-testid="go-market-btn"
          >
            <Search className="w-5 h-5" />
            Markete Git
          </Link>
        </div>
        <button 
          onClick={() => window.history.back()}
          className="mt-6 inline-flex items-center gap-2 text-[#5C5C5C] hover:text-[#1A3625] transition-colors text-base"
          data-testid="go-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Önceki Sayfaya Dön
        </button>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
